import Documents from './styled';
export default Documents;
